import { cn } from "@omni/utils/styles";

import { Input } from "@/components/Form/Base/input.component";
import { InputGroup } from "@/components/Form/Base/inputGroup.component";
import { InputGroupText } from "@/components/Form/Base/inputGroupText.component";
import { Label } from "@/components/Form/Base/label.component";
import { Col, ColumnProps } from "@/components/General/Grid/col.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

export type CalculationFieldProps = {
    name: string;
    dimension: string;
    unit: string | null;
    sup?: number | undefined;
    setCalculationValue: (name: string, value: string) => void;
    value?: any | undefined;
    sm?: ColumnProps;
    md?: ColumnProps;
    lg?: ColumnProps;
    classNames?: string;
};

const CalculationField = ({
    name,
    dimension,
    unit,
    sup,
    setCalculationValue,
    value,
    sm,
    md,
    lg,
    classNames
}: CalculationFieldProps) => {
    const { t } = useGranite();

    const validateNumber = (e: any) => {
        if (
            e.keyCode === 46 || // left
            e.keyCode === 8 || // right
            e.keyCode === 9 || // tab
            e.keyCode === 39 || // backspace
            e.keyCode === 37 // delete
        ) {
            return true;
        }

        if (
            // input is not number or , or .
            !/[\d,.]/.test(e.key) ||
            // number is not formatted with ',' as decimal point
            !/^\d*[.,]?(\d*)?$/.test(e.target.value + e.key)
        ) {
            return e.preventDefault();
        }

        return true;
    };

    const formatNumber = (e: any) => {
        return e.target.value.replace(",", ".");
    };

    return (
        <Col
            sm={sm}
            md={md}
            lg={lg}
            className={cn("mt-3", classNames)}
        >
            <Label htmlFor={name}>{t(`calculator.${dimension}`)}</Label>
            <InputGroup>
                <Input
                    name={name}
                    type="text"
                    inputMode="decimal"
                    maxLength={6}
                    placeholder="0"
                    onKeyDown={(e) => validateNumber(e)}
                    onChange={(e) => setCalculationValue(name, formatNumber(e))}
                    value={value}
                />
                {unit && (
                    <InputGroupText>
                        {unit}
                        {unit && sup && <sup>{sup}</sup>}
                    </InputGroupText>
                )}
            </InputGroup>
        </Col>
    );
};

export default CalculationField;
